export function brandFamilyPageParamsFields(id: number, name: string) {
  return { brandFamilyId: id, brandFamilyName: name };
}

export function brandFamilyPageParamsUrlString(id: number, name: string) {
  return `/product_listing?brandFamilyId=${id}&brandFamilyName=${name}`;
}
